import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DadosFranquiaRoutingModule } from './dados-franquia-routing.module';
import { DadosFranquiaComponent } from './dados-franquia.component';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { MessagesModule } from 'primeng/messages';
import { DividerModule } from 'primeng/divider';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { InputMaskModule } from 'primeng/inputmask';
import { FormatPipeModule } from 'src/app/admihair/format-pipe/format-pipe.module';


@NgModule({
  declarations: [
    DadosFranquiaComponent
  ],
  imports: [
    CommonModule,
    DadosFranquiaRoutingModule,
    FormsModule,
    InputTextModule,
    InputMaskModule,
    ButtonModule,
    DropdownModule,
    MessagesModule,
    DividerModule,
    ProgressSpinnerModule,
    FormatPipeModule
  ]
})
export class DadosFranquiaModule { }
